<template>
    <section class="monitoringUsers">
      <ul>
        <user v-for="user in users" :key="user.id" :user="user" />
      </ul>
    </section>
</template>

<script>
import User from './User'

export default {
  name: 'MonitoringUser',
  components: { User },
  computed: {
    users () { return this.$store.getters['Server/users'] }
  }
}
</script>

<style>
.monitoringUsers {
  position:relative;
}
.monitoringUsers ul{
  padding:0
}
</style>
